import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Space, Table, Tag, Typography, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { listForms, updateForm } from "../../../redux/actions/formsAction";
import useTableScrollY from "../../../hooks/useTableScrollY";
import DeleteRecord from "../../../components/modals/deleteRecord";

const { Title, Text } = Typography;

export default function FormsList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formsList = useSelector((state) => state.forms.forms);
  const [loading, setLoading] = useState(false);
  const [tableAreaRef, tableScrollY] = useTableScrollY([
    loading,
    formsList.length,
  ]);

  const fetchForms = useCallback(() => {
    setLoading(true);
    dispatch(listForms({ pageSize: 50, pageNum: 1 }))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    fetchForms();
  }, [fetchForms]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name, record) => (
        <Button type="link" onClick={() => navigate(`/app/forms/${record._id}`)}>
          {name}
        </Button>
      ),
    },
    {
      title: "Public ID",
      dataIndex: "publicId",
      key: "publicId",
      ellipsis: true,
    },
    {
      title: "Submissions",
      dataIndex: "submissionCount",
      key: "submissionCount",
    },
    {
      title: "Promotion",
      dataIndex: "contactPromotion",
      key: "contactPromotion",
      render: (v) => <Tag>{v}</Tag>,
    },
    {
      title: "Enabled",
      dataIndex: "enabled",
      key: "enabled",
      render: (enabled, record) => (
        <Switch
          checked={enabled}
          onChange={(checked) => {
            dispatch(updateForm({ enabled: checked }, record._id)).then(() =>
              fetchForms(),
            );
          }}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <DeleteRecord
          id={record._id}
          collection="forms"
          fetchRecords={fetchForms}
        />
      ),
    },
  ];

  return (
    <div className="Forms">
      <Space
        wrap
        style={{
          display: "flex",
          margin: "0 0.5rem 0.25rem 0.5rem",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Title level={5} style={{ marginBottom: 0 }}>
            Forms
          </Title>
          <Text type="secondary">
            Capture leads from any website. Submissions stay in the inbox until you add
            them to contacts.
          </Text>
        </div>
        <Space size="small">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate("/app/forms/new")}
          >
            New form
          </Button>
        </Space>
      </Space>

      {formsList.length === 0 && !loading ? (
        <Text type="secondary" style={{ display: "block", margin: "0 0.5rem" }}>
          No forms yet. Create a form to get an embeddable endpoint for your site.
        </Text>
      ) : (
        <div ref={tableAreaRef} style={{ width: "100%" }}>
          <Table
            rowKey="_id"
            loading={loading}
            columns={columns}
            dataSource={formsList}
            scroll={{
              x: 1000,
              y: tableScrollY,
            }}
            pagination={false}
          />
        </div>
      )}
    </div>
  );
}
